import angular from 'angular'
import axios from 'axios'

function TermsOfServiceController ($scope) {
  const vm = this

  vm.CONTENT = {
    header: {
      headerImage: null,
      headerImageTitle: 'Body mind spirit',
      headerImageText: 'Terms of Service'
    },
    content: ''
  }

  axios.get(process.env.NODE_ENV === 'production' ? `${process.env.APP_URL}/jSON/TermsData.php` : `${process.env.LOCAL_APP_URL}/jSON/TermsData.php`).then(response => {
    if (response.status === 200) {
      const data = response.data

      vm.CONTENT.header = data.header
      vm.CONTENT.content = data.content

      $scope.$apply()
    }
  })
}

angular.module('app').controller('TermsOfServiceController', ['$scope', TermsOfServiceController])
